<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Visualizar Filial
                                <span class="required_fields text-white">
                                    <!-- <span class="required">*</span> Campos obrigatórios -->
                                </span>
                            </div>
                        </div>
                        <div class="card-body">
                            <form id="form">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="brand">
                                                <span class="required">*</span>
                                                Nome:
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="branch.description"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="brand">
                                                <span class="required">*</span>
                                                Rodízio:
                                            </label>
                                            <select
                                                v-model="branch.caster"
                                                class="form-control"
                                                disabled
                                            >
                                                <option value="1">Sim</option>
                                                <option value="0">Não</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="brand">
                                                <span class="required">*</span>
                                                Vagas:
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="branch.vacancies"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="brand">
                                                <span class="required">*</span>
                                                Endereço:
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="branch.address"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="brand">
                                                <span class="required">*</span>
                                                Número:
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="branch.number"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="brand">
                                                <span class="required">*</span>
                                                Bairro:
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="branch.neighborhood"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="brand">
                                                <span class="required">*</span>
                                                CEP:
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-mask="'#####-###'"
                                                v-model="branch.zip_code"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="brand">
                                                <span class="required">*</span>
                                                Estado:
                                            </label>
                                            <select
                                                class="form-control"
                                                v-model="branch.state"
                                                disabled
                                            >
                                                <option
                                                    v-for="state in states"
                                                    :key="state.id"
                                                    :value="state.id"
                                                >{{ state.title }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="brand">
                                                <span class="required">*</span>
                                                Cidade:
                                            </label>
                                            <select
                                                class="form-control"
                                                v-model="branch.city"
                                                disabled
                                            >
                                                <option
                                                    v-for="city in filteredCities"
                                                    :key="city.id"
                                                    :value="city.id"
                                                >{{ city.title }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="brand">
                                                <span class="required">*</span>
                                                Telefone:
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="branch.telephone"
                                                v-mask="'(##) #####-####'"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="brand">
                                                <span class="required">*</span>
                                                E-mail:
                                            </label>
                                            <input
                                                type="email"
                                                class="form-control"
                                                v-model="branch.email"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="col-12">

                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Veículos nesta Filial
                                <span class="required_fields text-white">
                                    <!-- <span class="required">*</span> Campos obrigatórios -->
                                </span>
                            </div>
                        </div>


                            <template>
                                <div>
                                    <base-crud
                                        :table="table"
                                        :columns="columns"
                                        :options="options"
                                        :endPoint="endPoint"
                                        :enableAdd="false"
                                        :enableEdit="false"
                                        :enableDelete="false"
                                        :enableView="false"
                                        :dataForm="dataForm"
                                    ></base-crud>
                                </div>
                            </template>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
    data() {
        return {
            //Crud de Veículos
            table: "vehiclesTable",
            pages: [],
            url: "",
            columns: [
                "id",
                "description",
                // "brand",
                "board",
                "model_year",
                "combustible",
                "branch_id",
                "vehicle_status_id"
                // "actions"
            ],
            tableData: [
                "id",
                "description",
                // "brand",
                "board",
                "model_year",
                "combustible",
                "branch_id",
                "vehicle_status_id"
            ],
            options: {
                filterByColumn: true,
                debounce: 1000,
                filterable: [
                    "description",
                    //   "brand",
                    "board",
                    "model_year",
                    "combustible",
                    "branch_id",
                    "vehicle_status_id"
                ],
                pagination: {chunk: 10, dropdown: false, nav: "scroll"},
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: "ID",
                    description: "Descrição",
                    //   brand: "Marca",
                    board: "Placa",
                    model_year: "Ano",
                    combustible: "Combustível",
                    branch_id: "Filial",
                    vehicle_status_id: "Status"
                    // actions: "Ações"
                },
                texts: {
                    filterBy: "Filtrar",
                    defaultOption: "Selecione o Status"
                },
                listColumns: {
                    vehicle_status_id: [
                        {
                            id: "INDISPONÍVEL",
                            text: "INDISPONÍVEL"
                        },
                        {
                            id: "DISPONÍVEL",
                            text: "DISPONÍVEL"
                        }
                    ]
                },
                templates: {
                    vehicle_status_id: function (h, row, index) {
                        return row.vehicle_status
                            ? row.vehicle_status.description
                            : "Sem Status";
                    },
                    branch_id: function (h, row, index) {
                        return row.branch ? row.branch.description : "Sem Status";
                    }
                },
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = ["vehicle_status", "branch"];

                    return this.$http.get(this.url + "?" + query, requestData).catch(
                        function (e) {
                            this.dispatch("error", e);
                        }.bind(this)
                    );
                }
            },
            endPoint: "vehicles/",
            dataForm: {},

            //Others
            branch: {
                caster: "0",
                branch: "",
                address: "",
                telephone: "",
                city: "",
                state: "",
                vacancies: ""
            },
            states: [],
            cities: []
        };
    },
    computed: {
        filteredCities: function () {
            return this.cities.filter(x => x.state_id == this.branch.state);
        }
    },
    methods: {
        query: function (query) {
            let columns = {
                id: "id",
                description: "description",
                // brand: "brand",
                board: "board",
                model_year: "model_year",
                combustible: "combustible",
                branch_id: "branch[description]",
                vehicle_status_id: "vehicle_status[description]"
            };
            let filters = "branch_id=" + this.$route.params.id;
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });
            return filters;
        },
        getBranch: function (id) {
            const self = this;
            const api = self.$store.state.api + "branches/" + id;

            self.$http
                .get(api)
                .then(response => {
                    self.branch = response.data.data[0];
                })
                .catch(error => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        getStates: function (id) {
            const self = this;
            const api = self.$store.state.api + "states?paginated=false";

            self.$http
                .get(api)
                .then(response => {
                    self.states = response.data.data;
                })
                .catch(error => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        getCities: function (id) {
            const self = this;
            const api = self.$store.state.api + "cities?paginated=false";

            self.$http
                .get(api)
                .then(response => {
                    self.cities = response.data.data;
                })
                .catch(error => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        }
    },
    mounted: function () {
        const self = this;
        self.getStates();
        self.getCities();
        let id = self.$route.params.id;
        if (id) {
            self.getBranch(id);
        }
    },
    components: {
        BaseCrud
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Branches/View.vue